export const isObject = (value: any) =>
  value != null && value.constructor.name === "Object";

export const isEmptyObject = (value: any) =>
  value.constructor === Object &&
  (Object.keys(value).every(key => !value[key]) ||
    Object.keys(value).length === 0);
